module.exports = __webpack_public_path__ + "static/media/logo.e495037a.png";